import React from "react";
import PropTypes from "prop-types";
import { Tooltip, makeStyles, mergeClasses } from "@fluentui/react-components";
import {
  CheckmarkCircle16Filled,
  DismissCircle16Filled,
  ArrowSync16Regular,
} from "@fluentui/react-icons";
import {
  EMBEDDING_FAILED,
  EMBEDDING_IN_PROCESS,
  EMBEDDING_READY,
  getEmbeddingStatusTooltip,
} from "../utils/resourceUtils";

const ICON_SIZE = 16;

const useStyles = makeStyles({
  iconWrap: {
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: `${ICON_SIZE}px`,
    height: `${ICON_SIZE}px`,
    lineHeight: 0,
    "& svg": {
      width: `${ICON_SIZE}px`,
      height: `${ICON_SIZE}px`,
    },
  },
  icon: {
    width: `${ICON_SIZE}px`,
    height: `${ICON_SIZE}px`,
    fontSize: `${ICON_SIZE}px`,
    display: "block",
  },
  spin: {
    animationDuration: "1.2s",
    animationIterationCount: "infinite",
    animationName: {
      from: { transform: "rotate(0deg)" },
      to: { transform: "rotate(360deg)" },
    },
    animationTimingFunction: "linear",
  },
});

const iconStyle = {
  width: ICON_SIZE,
  height: ICON_SIZE,
  fontSize: ICON_SIZE,
};

const EmbeddingStatusIcon = ({ embeddingStatus, className }) => {
  const styles = useStyles();
  const tooltip = getEmbeddingStatusTooltip(embeddingStatus);

  if (!tooltip) {
    return null;
  }

  let icon = null;
  const iconClass = styles.icon;

  if (embeddingStatus === EMBEDDING_FAILED) {
    icon = (
      <DismissCircle16Filled
        className={iconClass}
        style={iconStyle}
        primaryFill="#C50F1F"
        aria-label={tooltip}
      />
    );
  } else if (embeddingStatus === EMBEDDING_IN_PROCESS) {
    icon = (
      <ArrowSync16Regular
        className={mergeClasses(iconClass, styles.spin)}
        style={iconStyle}
        primaryFill="#CA5010"
        aria-label={tooltip}
      />
    );
  } else if (embeddingStatus === EMBEDDING_READY) {
    icon = (
      <CheckmarkCircle16Filled
        className={iconClass}
        style={iconStyle}
        primaryFill="#107C10"
        aria-label={tooltip}
      />
    );
  }

  if (!icon) {
    return null;
  }

  return (
    <Tooltip content={tooltip} relationship="description" withArrow showDelay={300}>
      <span className={mergeClasses(styles.iconWrap, className)}>{icon}</span>
    </Tooltip>
  );
};

EmbeddingStatusIcon.propTypes = {
  embeddingStatus: PropTypes.string,
  className: PropTypes.string,
};

export default EmbeddingStatusIcon;
